import { render, staticRenderFns } from "./UserBase.vue?vue&type=template&id=0649685f&scoped=true&"
import script from "./UserBase.vue?vue&type=script&lang=js&"
export * from "./UserBase.vue?vue&type=script&lang=js&"
import style0 from "./UserBase.vue?vue&type=style&index=0&id=0649685f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0649685f",
  null
  
)

export default component.exports